import { ICONS } from '../../constants/icons/icons.constant'

/**
 * @file Defines the {@link PAYTABLE_SECTIONS} constant
 * @author Joe Thompson <joe.thompson@1x2network.com>
 * @version 1.0.29
 */

//Function to determine if section should be hidden
let hidden = (id_) => {

  //If win lines/ways section
  if (id_ === 'winLinesWays') {

    let gameIDs = [ 23, 24, 25, 26, 27, 28, 29, 31, 33, 34 ]    //Last 2 digit of Game ID's to hide section on CA jurisdiction

    let hidden = [ 'CA', 'LQ' ] //Jurisdictions to hide section

    //Determine if section should be hidden
    return hidden.indexOf(loginVars.getRegParams().jurisdiction.toUpperCase()) > -1 && gameIDs.indexOf(Number(loginVars.getGameParams().gameID.slice(-2))) > -1

  }

}

 /**
  * Config for sections in new ui paytable
  * @type {object}
  * @default
  * @constant
  * @property {paytable-config} gameGuide    - Game guide config
  * @property {paytable-config} payout       - Payout config
  * @property {paytable-config} winLinesWays - Win lines/ways config
  * @property {paytable-config} exit         - Exit config
  */
 const PAYTABLE_SECTIONS = {

   gameGuide:    { id: 'GameGuide', icon: ICONS.gameGuide },
   payout:       { id: 'Payout', icon: ICONS.payout },
   winLinesWays: { id: 'WinLinesWays', icon: ICONS.winLinesWays, hidden: hidden },
   exit:         { id: 'Exit', icon: ICONS.exit.mobile }

 }

 export { PAYTABLE_SECTIONS }